module.exports = __webpack_public_path__ + "static/media/test_specialFormatting_avatars.d9586605.csv";